import React from "react"
import { Link } from "react-router"
import FontAwesome from "react-fontawesome"

export default function FinanciersMenu() {

  const customMenu = (url, icon, title, desc, className) => (
    <div className={`menu-item-contenair align-center p-10 ${ className }`}>
      <Link to={ url } className='pt-20 display-block'>
        <FontAwesome name={ icon } size='3x' />
        <h3>{ title }</h3>
        <p>{ desc }</p>
      </Link>
    </div>
  )

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10 mv-20 sm:mt-40">

      { customMenu(
        '/financiers/batches',
        'folder-open',
        'Batches',
        'Manage batches for financiers',
        'menu-1'
      )}

      { customMenu(
        '/financiers/buckets',
        'folder',
        'Buckets',
        'Manage buckets for financiers',
        'menu-2'
      )}

      { customMenu(
        '/financiers/investors',
        'fire',
        'Investors',
        'Manage investors',
        'menu-3'
      )}

      { customMenu(
        '/financiers/investors/payments',
        'compass',
        'Investor Payments',
        'All investor payments',
        'menu-1'
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Menu.js